import React from 'react';
import { MultiSelect } from '@mantine/core';
import { Button } from '../../../components/Button';
import classes from '../monitoring-page.module.scss';

type KitchenPrintsFiltersProps = {
  companyFilter: string[];
  setCompanyFilter: (value: string[]) => void;
  sessionFilter: string[];
  setSessionFilter: (value: string[]) => void;
  orderFilter: string[];
  setOrderFilter: (value: string[]) => void;
  companyOptions: { value: string; label: string }[];
  sessionOptions: { value: string; label: string }[];
  orderOptions: { value: string; label: string }[];
  clearFilters: () => void;
};

export const KitchenPrintsFilters: React.FC<KitchenPrintsFiltersProps> = ({
  companyFilter,
  setCompanyFilter,
  sessionFilter,
  setSessionFilter,
  orderFilter,
  setOrderFilter,
  companyOptions,
  sessionOptions,
  orderOptions,
  clearFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <MultiSelect
          label={'חברה'}
          placeholder={'בחר חברות'}
          data={companyOptions}
          value={companyFilter}
          onChange={setCompanyFilter}
          searchable
          clearable
          data-testid="monitoring-kitchen-company"
        />
      </div>

      <div className={classes.fieldStack}>
        <MultiSelect
          label={'משמרת'}
          placeholder={'בחר משמרות'}
          data={sessionOptions}
          value={sessionFilter}
          onChange={setSessionFilter}
          searchable
          clearable
          data-testid="monitoring-kitchen-session"
        />
      </div>

      <div className={classes.fieldStack}>
        <MultiSelect
          label={'הזמנה'}
          placeholder={'בחר הזמנות'}
          data={orderOptions}
          value={orderFilter}
          onChange={setOrderFilter}
          searchable
          clearable
          data-testid="monitoring-kitchen-order"
        />
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearFilters} dataTestId="monitoring-kitchen-clear">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
